import { Reducer } from 'redux'
import { SharedAction } from 'shared/Types/actionTypes'
import { MeetingModalActionTypes } from 'shared/Modules/Meeting/meetingModalActions'

export interface IMeetingDeletedModal {
    open: boolean
}

const initialState: IMeetingDeletedModal = {
    open: false
}

export const meetingDeletedModalReducer: Reducer<IMeetingDeletedModal, SharedAction> = (state = initialState, action) => {
    switch (action.type) {
        case MeetingModalActionTypes.OPEN_MEETING_DELETED_MODAL:
            return {
                ...state,
                open: true,
            }
        case MeetingModalActionTypes.CLOSE_MEETING_DELETED_MODAL:
            return {
                ...state,
                open: false,
            }
        default:
            return state
    }
}
